export default __webpack_public_path__ + "static/media/icoBac.1e275cfb.png";